import React, { useState, useContext } from "react";

import MainSearch from "./SearchFilter";
import MainFilter from "../common/MainFilter";

import db from "../../services/query";

import { YearContext } from "../../contexts/yearContext";

const Filter = ({ query, hasFilter }) => {
  const [filter, showFilter] = useState(false);

  const [genderList, getGender] = useState([]);
  const [positionList, setPositions] = useState([]);
  const [sectionList, setSections] = useState([]);

  const { entryYear } = useContext(YearContext);

  useState(async () => {
    const ac = new AbortController();

    await db
      .getAll(`dropdowns/genders`)
      .then(({ data: { data } }) => getGender(data));
    await db
      .getAll(`dropdowns/staffPositions`)
      .then(({ data: { data } }) => setPositions(data));
    await db
      .getAll(`dropdowns/staffSections`)
      .then(({ data: { data } }) => setSections(data));

    return () => ac.abort();
  }, []);

  const inputs = [
    {
      name: "staff_name",
      label: "نام",
      type: "text",
      maxLength: 32,
    },
    {
      name: "staff_phone",
      label: "شماره تماس",
      type: "text",
      maxLength: 14,
    },
    {
      name: "gender_id",
      label: "جنسیت",
      type: "select",
      data: genderList,
    },
    {
      name: "position_id",
      label: "وظیفه",
      type: "select",
      data: positionList,
    },
    {
      name: "section_id",
      label: "بخش",
      type: "select",
      data: sectionList,
    },
    {
      name: "aria_id",
      label: "کد کارمند",
      type: "text",
      maxLength: 20,
    },
    {
      name: "user_status",
      label: "وضعیت",
      type: "select",
      data: [{id: "1" , name: "برحال"}, {id: "0", name: "اسبق"}],
    }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();

    const {
      staff_name,
      staff_phone,
      gender_id,
      position_id,
      section_id,
      aria_id,
      user_status,
    } = e.target;

    query({
      keyword: staff_name.value,
      staff_phone: staff_phone.value,
      gender_id: gender_id.value,
      position_id: position_id.value,
      section_id: section_id.value,
      aria_id: aria_id.value,
      user_status: user_status.value,
    });
  };

  return (
    <React.Fragment>
      <MainSearch showFilter={showFilter} query={query} hasFilter={hasFilter}  />
      {filter && (
        <MainFilter
          handleSubmit={handleSubmit}
          showFilter={showFilter}
          filter={filter}
          inputs={inputs}
          query={query}
        />
      )}
    </React.Fragment>
  );
};

export default Filter;
